import axiosInstance from "./axiosInstance";

export interface CurrencyApi {
  currencyId: number;
  currencyCode: string;
  currencyName: string;
  currencySymbol: string;
  exchangeRate: number;
  isBaseCurrency: boolean;
  isActive: boolean;
  createdAt: string;
  updatedAt?: string | null;
}

export interface CurrencyListResponse {
  items: CurrencyApi[];
  pageNo: number;
  pageSize: number;
  totalCount: number;
}

export interface CurrencyListQuery {
  searchText?: string | null;
  currencyName?: string | null;
  currencyCode?: string | null;
  isBaseCurrency?: boolean | null;
  isActive?: boolean | null;
  pageNo?: number;
  pageSize?: number;
}

export const getAuthHeader = () => {
  const token = localStorage.getItem("fhims_auth_token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const getCurrencies = async (
  params: CurrencyListQuery
): Promise<CurrencyListResponse> => {
  const res = await axiosInstance.get("/Currency/list", {
    params,
    headers: getAuthHeader(),
  });
  return res.data;
};

export interface CreateCurrencyPayload {
  currencyCode: string;
  currencyName: string;
  currencySymbol: string;
  exchangeRate: number;
  isBaseCurrency: boolean;
  isActive: boolean;
  createdBy: number;
}

export const createCurrency = async (
  payload: CreateCurrencyPayload
): Promise<CurrencyApi> => {
  const res = await axiosInstance.post("/Currency", payload,{
    headers: getAuthHeader(),
  });
  return res.data;
};

export interface UpdateCurrencyPayload {
  currencyId: number;
  currencyCode: string;
  currencyName: string;
  currencySymbol: string;
  exchangeRate: number;
  isBaseCurrency: boolean;
  isActive: boolean;
  updatedBy: number;
}

export const updateCurrency = async (
  currencyId: number,
  payload: UpdateCurrencyPayload
): Promise<void> => {
  await axiosInstance.put(`/Currency/${currencyId}`, payload,{
    headers: getAuthHeader(),
  });
};